(function () {
  angular.module("akitabox.qrCode").run(states);

  /* @ngInject */
  function states(Router, models) {
    var qrCodeUrl = "/" + models.QR_CODE.ROUTE_SINGULAR + "/:qrCodeId";
    Router.configureStates([
      {
        state: "app.qrCode",
        config: {
          url: qrCodeUrl,
          templateUrl: "<div></div>",
          controller: "QRCodeController",
          controllerAs: "vm",
          reloadOnSearch: false,
          resolve: {
            account: getIdentity,
            qrCode: getQrCode,
          },
          data: {
            pageTitle: "QR Code",
          },
        },
      },
    ]);

    var oldQrCodeUrl =
      "/" +
      models.BUILDING.ROUTE_PLURAL +
      "/:buildingId/" +
      models.QR_CODE.ROUTE_SINGULAR +
      "/:qrCodeId";
    Router.configureRedirect(oldQrCodeUrl, qrCodeUrl);
  }

  /** @ngInject */
  function getIdentity(IdentityService) {
    return IdentityService.getCurrent();
  }

  /** @ngInject */
  function getQrCode($location, $stateParams, $window, QRCodeService) {
    // Get the QR code defined in the URL, and use its appropriate redirect URL
    return QRCodeService.getById($stateParams.qrCodeId).then(function (qrCode) {
      if (qrCode.is_associated) {
        var url = QRCodeService.parse(qrCode).mobileUrl;
        $window.location.href = $location.protocol() + "://" + url;
      } else {
        return qrCode;
      }
      return null;
    });
  }
})();
